import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useI18n } from "@/contexts/i18n";
import { Box } from "@gemini/core";
import { Button, Modal } from "@gemini/ui";
import { useEllipsis, useTestId } from "@/hooks";
const Trigger = ({ ...rest }) => {
    const { t } = useI18n();
    return (_jsx(Button, { variant: "secondary", marginTop: "spacing.24", isFullWidth: {
            "breakpoint.base": true,
            "breakpoint.sm": false,
        }, ...rest, children: t("features.cta.read_more") }));
};
export const FeaturesTextOnly = ({ additionalText, }) => {
    const { t } = useI18n();
    const { ref, ellipsisStyle, hasButton } = useEllipsis(6);
    const testId = useTestId("Sections.Features.AdditionalText");
    if (!additionalText)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Box, { unsafe_style: ellipsisStyle, width: "100%", ref: ref, testId: testId, children: _jsx(Box, { as: "p", marginVertical: 0, dangerouslySetInnerHTML: { __html: additionalText } }) }), hasButton && (_jsxs(Modal, { title: t("features.h1"), titleAs: "h2", isDismissable: true, trigger: Trigger, children: [_jsx(Box, { as: "span", typography: "typography.headline.22.bold", children: t("features.category.additional_information") }), _jsx(Box, { as: "p", marginBottom: 0, dangerouslySetInnerHTML: { __html: additionalText } })] }))] }));
};
